import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import style from "./PageLoadingSpinner.module.css";

const spinIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const PageLoadingSpinner = () => (
  <Spin indicator={spinIcon} size="large" className={style.spinner} />
);
